import React, { useState, useContext } from 'react'
import { M_InputTextField, M_MessageBoard, M_Button, BufferService, LoadingContext } from '../M_Components'
import { useTranslation } from 'react-i18next'
import { Clear, Done } from '@mui/icons-material'

export default function ModalChange({ openModalPassword, setOpenModalPassword }) {
    const ctx = useContext(LoadingContext)
    const backendPut = new BufferService('identity/forgetpassword')
    const [userEmail, setUserEmail] = useState("")
    const { t } = useTranslation()

    const backendCall = (e) => {
        ctx.setIsLoad(true)

        let tempEmail = {
            'Email': userEmail,
        }

        if (userEmail === "") {
            ctx.setIsLoad(false)
            ctx.toastMessages("error", t("LabelTryAgain"), '')
        }
        else {
            backendPut.put(tempEmail).then(response => {
                ctx.setIsLoad(false)
                if (response.name === 'AxiosError') {
                    ctx.toastMessages("error", t("LabelTryAgain"), '')
                    return
                }
                ctx.toastMessages("success", "", t("LabelEmailSentSuccessfully"))
                setOpenModalPassword(false)
                setUserEmail("")
            })
        }
    }

    const footer = () => {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <div style={{ marginRight: '20px' }}>
                    <M_Button
                        icon={<Clear style={{ color: 'var(--color-white)' }} />}
                        label={t("ButtonCancel")}
                        labelColor={'var(--color-white)'}
                        onClick={() => {
                            setOpenModalPassword(false)
                            setUserEmail("")
                        }}
                        backgroundColor={"var(--color-red)"}
                    />
                </div>
                <div>
                    <M_Button
                        label={t("ButtonConfirm")}
                        labelColor={'var(--color-white)'}
                        icon={<Done style={{ color: 'var(--color-white)' }} />}
                        onClick={() => { backendCall() }}
                        backgroundColor={"var(--color-green)"}
                    />
                </div>
            </div>
        )
    }

    return (
        <M_MessageBoard
            width={"300px"}
            minWidth={"auto"}
            open={openModalPassword}
            title={t("ForgotPassword")}
            body={<M_InputTextField
                label={"Email"}
                type={"email"}
                value={userEmail || ""}
                onChange={(e) => setUserEmail(e.target.value)}
            />}
            footer={footer()}
        />
    )
}